import { useEffect, useRef } from "react";
import LoadingBar, { LoadingBarRef } from "react-top-loading-bar";

import Loader from "components/Loader";

interface LoadingProgressBarProps {
  loading: boolean;
}

const LoadingProgressBar = ({ loading }: LoadingProgressBarProps) => {
  const progressRef = useRef<LoadingBarRef>(null);

  useEffect(() => {
    if (progressRef?.current) {
      if (loading) {
        progressRef.current.staticStart();
        progressRef.current.continuousStart();
      } else {
        progressRef.current.complete();
      }
    }
  }, [loading]);

  return (
    <div>
      <LoadingBar
        ref={progressRef}
        color="#007AF5"
        shadowStyle={{
          boxShadow: "#007af5 0px 0px 10px, #007af5 0px 0px 10px",
        }}
      />

      {loading && (
        <div className="relative z-[99999]">
          <div className="fixed top-[1.2rem] right-[2.2rem]">
            <Loader className="w-[1.5rem] h-[1.5rem] border-[2px] rounded-[100%] border-x-[#007af5] border-b-[#007af5] animate-spinner0_5" />
          </div>
        </div>
      )}
    </div>
  );
};

export default LoadingProgressBar;
